// Check if already initialized to prevent duplicate declarations
if (typeof window.mdlrHeaderScrollPos === 'undefined') {
  window.mdlrHeaderScrollPos = 0;
}

if (typeof window.modulrHeaderScroll === 'undefined') {
  window.modulrHeaderScroll = function() {
    const headers = document.querySelectorAll('.wp-block-modulr-header');
    if (!headers || headers.length === 0) return;

    const wh = window.innerHeight;
    const topCompare = -(document.body.getBoundingClientRect()).top;

    headers.forEach(header => {
      const headerState = header.getAttribute('data-header-state') || 'default';
      const animationType = header.getAttribute('data-animation-type') || 'slide';

      // Handle default state (original behavior)
      if (headerState === 'default') {
        if (topCompare < window.mdlrHeaderScrollPos || topCompare < wh / 3) {
          header.classList.remove('inactive');
        } else {
          header.classList.add('inactive');
        }
        return;
      }

      // Handle above-fold headers
      if (headerState === 'above-fold') {
        if (topCompare > wh / 3) {
          // Scrolled past threshold - hide above-fold header
          header.classList.add('inactive');
        } else {
          // At top or scrolling up - show above-fold header
          header.classList.remove('inactive');
        }
        return;
      }

      // Handle below-fold headers
      if (headerState === 'below-fold') {
        if (topCompare > wh / 3) {
          // Scrolled past threshold - show below-fold header
          header.classList.remove('inactive');
        } else {
          // At top or before threshold - hide below-fold header
          header.classList.add('inactive');
        }
        return;
      }
    });

    window.mdlrHeaderScrollPos = topCompare;
  };

  // Initialize headers on DOM ready
  document.addEventListener("DOMContentLoaded", () => {
    // Set initial state for below-fold headers (they should start inactive)
    const belowFoldHeaders = document.querySelectorAll('[data-header-state="below-fold"]');
    belowFoldHeaders.forEach(header => {
      header.classList.add('inactive');
    });

    // Set initial state for above-fold headers (they should start active)
    const aboveFoldHeaders = document.querySelectorAll('[data-header-state="above-fold"]');
    aboveFoldHeaders.forEach(header => {
      header.classList.remove('inactive');
    });

    // Set up scroll listener
    window.addEventListener('scroll', window.modulrHeaderScroll);
    
    // Run once on load to set initial state
    window.modulrHeaderScroll();
  });
}

